module.exports = __webpack_public_path__ + "img/actions.4d7ae910.svg";